import {Field, FieldArray, useFormikContext} from 'formik';
import {Stack} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {
    FlexiAddButton,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset,
} from '@flexinet/ui-components';

import {DimensionFields} from './DimensionFields';
import {FieldError} from './FieldError';
import {emptyDimension} from './buildInitialValues';
import {MAX_DIMENSIONS, ProductFormValues} from '../types';

// Field names are the API input's names exactly.
export const FormComponent = () => {
    const {values} = useFormikContext<ProductFormValues>();

    return (
        <Stack>
            <PlatformFieldset legend={I18n.get('Product')}>
                <Stack>
                    <Field
                        name='name'
                        label={I18n.get('Name')}
                        component={FormikTextInput}
                        withAsterisk
                    />
                    <Field
                        name='summary'
                        label={I18n.get('Summary')}
                        description={I18n.get('One line shown in listings')}
                        component={FormikTextInput}
                        withAsterisk
                    />
                    <Field
                        name='description'
                        label={I18n.get('Description')}
                        component={FormikTextarea}
                        rows={4}
                        withAsterisk
                    />
                    <Field
                        name='eulaUrl'
                        label={I18n.get('EULA link')}
                        description={I18n.get('Must start with https://')}
                        component={FormikTextInput}
                        withAsterisk
                    />
                    <Field
                        name='supportContact'
                        label={I18n.get('Support contact')}
                        component={FormikTextInput}
                        withAsterisk
                    />
                </Stack>
            </PlatformFieldset>

            <PlatformFieldset legend={I18n.get('Pricing units')}>
                <FieldArray name='dimensions'>
                    {({push, remove}) => (
                        <Stack>
                            {values.dimensions.map((dimension, index) => (
                                <DimensionFields
                                    key={index}
                                    index={index}
                                    dimension={dimension}
                                    onRemove={() => remove(index)}
                                />
                            ))}
                            <FieldError name='dimensions'/>
                            <div>
                                <FlexiAddButton
                                    disabled={values.dimensions.length >= MAX_DIMENSIONS}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        push(emptyDimension());
                                    }}
                                >
                                    {I18n.get('Add pricing unit')}
                                </FlexiAddButton>
                            </div>
                        </Stack>
                    )}
                </FieldArray>
            </PlatformFieldset>
        </Stack>
    );
};
